import React from 'react';
import { Modal, ModalTitle, ModalDescription } from '@lux/modal';
import { screenSizes } from '@lux/core';
import { useSelector } from 'react-redux';
import { getClientDeviceWidth } from '@client/redux/modules/clientDevice';
import {
    ModalOverlay,
    ModalWrapper,
} from '@client/components/mylounge/plus/benefits/free-delivery/styles';
import { Translate, useFormatters } from '@pegasus/translation';
import { ChevronLeft } from '@lux/zds-icons';
import { TitlePreset } from '@lux/title';
import { Preset, Text } from '@lux/text';
import { useUnlimitedFreeDelivery } from '@client/components/mylounge/plus/use-unlimited-free-delivery';

type FreeDeliveryTermsConditionsModalProps = {
    open: boolean;
    onBack: () => void;
};

export const FreeDeliveryTermsConditionsDialog = ({
    open,
    onBack,
}: FreeDeliveryTermsConditionsModalProps) => {
    const deviceWidth = useSelector(getClientDeviceWidth);
    const isMobileView = deviceWidth < screenSizes.sm;
    const { formatPrice } = useFormatters();
    const { minimumOrderValue, month } = useUnlimitedFreeDelivery();

    return (
        <Modal
            dismissable
            open={open}
            purpose="NON_COMMERCIAL"
            role="dialog"
            size="S"
            sizeSm="S"
            mobileFullScreen={isMobileView}
        >
            <ModalOverlay
                dismissLabel="Close dialog"
                withoutCloseIcon
                onClick={onBack}
                withoutPadding
            >
                <ModalWrapper className="px-sm" onClick={e => e.stopPropagation()} isMember={true}>
                    <div className="py-s flex items-center justify-between">
                        <ChevronLeft onClick={onBack} cursor="pointer" />
                        <Text preset={Preset.M} bold>
                            <Translate
                                message="free_delivery.unlimited.member.popup.tnc.headerTitle"
                                raw
                            />
                        </Text>
                        <span />
                    </div>
                    {/* TODO used important styling because ModalTitle misbehave */}
                    <ModalTitle className="break-words !text-left" preset={TitlePreset.S}>
                        <Translate message="free_delivery.unlimited.member.popup.tnc.title" raw />
                    </ModalTitle>

                    <ModalDescription className="my-sm text-left">
                        <Text preset={Preset.M}>
                            <Translate
                                message="free_delivery.unlimited.member.popup.tnc.description"
                                params={{
                                    minimumOrderValue: formatPrice({
                                        cents: minimumOrderValue * 100,
                                        maximumFractionDigits: 0,
                                    }),
                                    month,
                                }}
                                html
                            />
                        </Text>
                    </ModalDescription>
                </ModalWrapper>
            </ModalOverlay>
        </Modal>
    );
};
